import { createStore } from '@aibees/shared/store';
import { BillingStoreData } from './types';

// TODO replace with new version
const usePriceAndPlanStore = createStore<BillingStoreData>(
  'price-plan-analysis-store',
  (set) => ({
    yearly: false,
    setYearly: (yearly) => set(() => ({ yearly })),
    toggleYearly: () => set((s) => ({ yearly: !s.yearly })),
  })
);

export default usePriceAndPlanStore;
